import { FC, PropsWithChildren, useMemo, useState } from 'react'

import { ChartDownload, DashboardDownloadContext } from './dashboardDownloadContext'

/**
 * Bridges the chart (`Chart`, in the page of a slide) to the Download menu (in the page
 * header, which the layout of the dashboard group draws). They are in different subtrees.
 */
export const DashboardDownloadProvider: FC<PropsWithChildren> = ({ children }) => {
  const [download, setDownload] = useState<ChartDownload>()
  const value = useMemo(() => ({ download, setDownload }), [download])
  return <DashboardDownloadContext value={value}>{children}</DashboardDownloadContext>
}
